module.exports = __webpack_public_path__ + "static/media/ancient-egyp.05d168a8.gif";